var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"type":"date","size":_vm.size,"value":_vm.formattedDate},on:{"change":_vm.formatDateToISO}})}
var staticRenderFns = []

export { render, staticRenderFns }